<template>
    <div class="wrapper" @click="global_clicked">            
        <h1 class="title">Identity Verification</h1>
        <div class="content">
            <div class="element-container" v-for="(item, ind) in obj.select_types" :key="ind">
                <template v-if="item.dataType=='0'">
                    <Dropdonw
                        :title="item.key"
                        :required="item.checkReq"
                        :choices="item.dictionaryVoList"
                        :keys="item.value"    
                        :is_show="item.is_show" 
                        :is_error="item.is_error"
                        :label="item.label"              
                        :component_id = "ind"                    
                        fromPage = "kyc_input_page"
                        :requestId = "requestId"
                        @modify="modify_dropdown"
                        @modifyError="modify_error"
                        @setValue="setValue"
                    >
                    </Dropdonw>        
                </template>
                
                <template  v-if="item.dataType=='1' && !item.readonly">
                    <MyInput
                        :title="item.key"
                        :component_id = ind
                        :required="item.checkReq"
                        :keys="item.value"
                        :label="item.label"
                        :is_show="item.is_show"
                        :is_error="item.is_error"
                        :checkType="item.checkType"
                        :maxlength="item.lengthLimitMax"
                        fromPage = "kyc_input_page"
                        :eventCount = item.eventCount
                        :requestId = "requestId"                        
                        @setCount="setCount"
                        @modifyError="modify_error"
                        @setValue="setValue"
                        @refreshRequestId="refreshRequestId"
                    >
                    </MyInput>
                </template>
                <template  v-if="item.dataType=='1' && item.readonly">
                    <MyReadOnlyInput
                        :title="item.key"
                        :component_id = ind
                        :required="item.checkReq"
                        :keys="item.value"
                        :label="item.label"
                        :is_show="item.is_show"
                        :is_error="item.is_error"
                        :checkType="item.checkType"
                        :maxlength="item.lengthLimitMax"
                        fromPage = "kyc_input_page"
                        :value="obj.params[item.value]['value']"
                        :readonly="item.readonly"
                        :eventCount = item.eventCount
                        :requestId = "requestId"                        
                        @setCount="setCount"
                        @modifyError="modify_error"
                        @setValue="setValue"
                        @refreshRequestId="refreshRequestId"
                    >
                    </MyReadOnlyInput>
                </template>
                <template v-if="item.dataType == '2'">
                    <div>
                        <MyDatePicker
                        :title="item.key"
                        :component_id = ind
                        :required="item.checkReq"
                        :keys="item.value"
                        :label="item.label"
                        :is_show="item.is_show"
                        :is_error="item.is_error"
                        :checkType="item.checkType"
                        :maxlength="item.lengthLimitMax"
                        fromPage = "kyc_input_page"
                        :eventCount = item.eventCount
                        :requestId = "requestId"
                        :value = "obj['params'][item.value].value"
                        @setCount="setCount"
                        @modifyError="modify_error"
                        @modify="modify_dropdown"
                        @setValue="setValue"
                        @refreshRequestId="refreshRequestId"
                        ></MyDatePicker>
                    </div>
                </template>
                <template  v-if="item.dataType=='4'">
                    <State
                        :title="item.key"
                        :required="item.checkReq"
                        :component_id = ind
                        :keys="item.value"
                        :is_error="item.is_error"
                        :is_show="item.is_show"
                        :label="item.label"
                        @setValue="setValue"
                        @modify="modify_normal"
                        @modifyError="modify_error"
                    >
                    </State>
                </template>
                <template  v-if="item.dataType=='5'">
                    <Location
                        :title="item.key"
                        :required="item.checkReq"
                        :component_id = ind
                        :keys="item.value"   
                        :label="item.label"   
                        :is_error="item.is_error"                  
                        :is_show="item.is_show"
                        :state_id = "state_id"
                        @setValue="setValue"
                        @modify="modify_normal" 
                        @modifyError="modify_error"                   
                    >
                    </Location>
                </template>
                
            </div>            
        </div>       
        <div class="placeholder"></div>
        <div class="btn-container">            
            <a class='btn-submit' :class='{"unactive":!btnStatus}' @click="submit">CONFIRM TO NEXT</a>
        </div>
                
    </div>
</template>
<style lang="less" scoped>
    .wrapper{
        padding:20px 40px;
        .guide{
            color:#A59BB3;
            font-size: 30px;
            em{
                color:#FF9110;
                font-weight: 700;
            }
        }
        .title{
            color:#1F201E;
            font-weight: 700;
            font-size: 40px;
            margin: 0 0 50px 0;  
        }
    }
    .btn-container{
        position: fixed;
        left:0;
        bottom: 0;        
        background:#fff;
        padding:40px;
        // padding:40px;
        .btn-submit{
            display: block;
            width: 670px;
            height: 96px;
            line-height: 96px;
            text-align: center;
            border-radius: 12px;
            background:#FF9110;
            font-size: 32px;
            margin:0 auto;
            color:#fff;
            &.unactive{
                background:#f0f0f0;
                color:#999
            }
        }
    }
    .placeholder{
        height: 176px;        
    }
</style>
<script>

import { reactive, onMounted, computed, ref , getCurrentInstance, onBeforeMount, onBeforeUnmount} from 'vue'
import {  manual_submit, identityConfig,getAadhaar  } from '@api/index'
import Dropdonw from '@/components/business/kyc/dropdown.vue'
import MyInput from '@/components/business/kyc/input.vue'
import MyReadOnlyInput from '@/components/business/kyc/readonly.vue'
import State from '@/components/business/kyc/state.vue'
import Location from '@/components/business/kyc/location.vue'
import MyDatePicker from '@/components/business/kyc/mydatepicker.vue'
import { useRouter } from 'vue-router'
import { useLoading } from 'vue-loading-overlay'
import { v4 as uuidv4} from 'uuid'
import { useStore } from 'vuex'

export default {
    components:{
        Dropdonw,
        MyInput,
        State,
        Location,
        MyDatePicker,
        MyReadOnlyInput
    },    
    setup () {
        const router = useRouter()
        const route = router.currentRoute
        const clicked = ref(false)
        const btnStatus = ref(false)
        const proxy  = getCurrentInstance().proxy
        const store = useStore()
        const idNo = ref("")
        let obj = reactive({
            select_types:[],
            input_types:[],
            state_types:[],
            district_types:[],            
            params:{
                "birthDate":[],
                "idNo":""
            }
        })
        const requestId = ref(uuidv4())
        const state_id = computed(()=>{
            return obj.params['liveState'].value
        })
        const validate = () => {
            let res = true
            for(let x in obj.params){
                if (obj.params[x].value == '') {
                    obj.select_types[obj.params[x].ind].is_error = false
                    res = false
                }
            }
            btnStatus.value = res
            return res
        }
        const $loading = useLoading()
        const globalClick = () => {           
            for (let x in obj.select_types){                
                if(obj.select_types[x].is_show && obj.select_types[x]['dataType'] == '0'){
                    uploadBury('complete', obj.params[obj.select_types[x]['value']].value, 1, x)
                    requestId.value = uuidv4()
                }
                obj.select_types[x].is_show = false
            }
        }
        onBeforeMount(()=>{
            store.dispatch('bury', {eventId:"kyc_input_page_view"})
            store.dispatch("clearBuryCache", [])
        })
        onBeforeUnmount(()=>{
            store.dispatch('bury', {eventId:"kyc_input_page_exit_page_tech"})
            store.dispatch("clearBuryCache", [])
        })
        const uploadBury = (type, value, numberTimes,x ) => {
            try {
                store.dispatch('buryCache', { 'event_id':  obj.select_types[x]['event_target'][type], value:value, requestId:requestId, numberTimes:numberTimes})           
            } catch (error) {
                console.log(error)    
            }
        }
        const submit = () => {            
            if(validate() && !clicked.value){
                clicked.value = true
                let loader = $loading.show({
                    container:null
                })
                let newParams = {}                
                for(let i in obj.params) {
                    newParams[i] = obj.params[i].value
                }
                store.dispatch("bury",{"event_id":"kyc_input_page_enter_button_click"})
                manual_submit(newParams).then((res)=>{
                    if(res.code == 0) {
                        store.dispatch("bury",{"event_id":"kyc_input_page_enter_button_click_success"})
                        store.dispatch("uploadBury")
                        router.replace({
                            "path":"/auth/index",
                            "query":{
                                "pid":route.value.query.pid
                            }
                        })
                    } else {
                        let error_text = ""
                        for(let i = 0 ; i<res.data.errorColumn.length;i++) {
                            error_text += `${i+1}.  ${res.data.errorColumn[i].msg} \n`
                        }
                        proxy.$toast.show(error_text)
                        store.dispatch("bury",{"event_id":"kyc_input_page_enter_button_click_success","msg":error_text})
                    }
                    loader.hide()
                    clicked.value = false
                }).catch(()=>{
                    clicked.value = false
                })
            }
        }
        onMounted(async () => {
            document.body.style.background = "#fff";
            const loader = proxy.$loading.show({
                container:null
            })
            let data = await identityConfig()
            loader.hide()
            console.log(data.data.KycPageInfoVo[0]);
            const finalArr = data.data.KycPageInfoVo[0].inputVos.concat(data.data.KycPageInfoVo[1].inputVos)

            let ada = await getAadhaar()
            idNo.value = ada.data.aadhaar || ""
            let select_type = finalArr.map((ele, ind)=>{
                ele.is_show = false
                ele.is_error = false
                
                if(ele.dataType == '0'|ele.dataType == '4'|ele.dataType == '5') {
                    ele.label = ele.label?ele.label:"Please select"
                } else if (ele.dataType == '1') {
                    ele.label = ele.label?ele.label:"Please input"
                } 
                if(ele.checkReq == 0) {
                    obj.params[ele.value] = {
                        "value":'',
                        "ind": ind,
                        "required":true
                    }
                    
                } else {
                    obj.params[ele.value] = {
                        "value":'',
                        "ind": ind,
                        "required":0
                    }
                }
                ele.event_target = store.state.buryConfig['baseinfo_page'][ele.value] || ""
                if(ele.dataType == '1') {
                    ele.eventCount = 0
                }           
                return ele
            })
            // .filter(element => {
            //     return element.dataType == '0'            
            // })
            obj.select_types = select_type.map((ele, ind)=>{
                ele.is_show = false                
                ele.is_error = false
                obj.params[ele.value] = {
                    "value":'',
                    "ind": ind
                }
                ele.readonly = false
                if(ele.value == 'idNo') {
                    if(idNo.value.length > 0) {
                        ele.readonly = true
                        obj.params['idNo']['value'] = idNo.value
                    }
                }
                
                return ele
            })                        
        })
        const modify_normal = (k, v) => {
            for (let x in obj.select_types){                
                obj.select_types[x].is_show = false
            }
            obj.select_types[k]['is_show'] = v           
        }
        const modify_dropdown = (k, v, dictValue,uid,event_id) => {            
            setTimeout(()=>{
                obj.select_types[k]['is_show'] = v 
                if(v){
                    store.dispatch('buryCache', { 
                        'event_id':  event_id, 
                        'value': dictValue, 
                        requestId:uid,
                        numberTimes:0
                    })
                    console.log(2)
                } else {
                    store.dispatch('buryCache', { 
                        'event_id':  event_id, 
                        value:dictValue, 
                        requestId:uid, 
                        numberTimes:1
                    })
                    refreshRequestId()   
                }  
            })
                  
                           
        }
        const setCount = (ind, count) => {
            obj.select_types[ind].eventCount = count
        }
        const refreshRequestId = () => {
            requestId.value = uuidv4()
        }                
        const modify_error = (k,v) =>{
            v = false
            obj.select_types[k]['is_error'] = v
        }
        const setValue = (k, v) => {       
            console.log("set")        
            obj.params[k].value = v
            validate()
        }                
        return {
            obj,
            setValue ,
            requestId,
            modify_normal,
            state_id,
            submit,
            modify_error,
            btnStatus,
            route,
            globalClick,
            setCount,
            refreshRequestId,
            modify_dropdown,
            idNo
        }
    }
}
</script>